import React, { useRef, useCallback } from 'react';
import Slider, { Settings } from 'react-slick';
import { GalleryProps } from 'contracts/gallery';
import * as S from './styles';

interface GalleryLeftProps {
  data: GalleryProps;
}
const GalleryLeft: React.FC<GalleryLeftProps> = ({ data }) => {
  const slideRef = useRef<Slider>(null);
  const sliderSettings: Settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  type Directions = 'next' | 'prev';
  const handleNavigation = useCallback((direction: Directions) => {
    if (slideRef.current) {
      if (direction === 'next') {
        slideRef.current.slickNext();
      }
      if (direction === 'prev') {
        slideRef.current.slickPrev();
      }
    }
  }, []);
  return (
    <S.Container>
      <S.Content>
        <S.Button className="left" onClick={() => handleNavigation('prev')}>
          <S.ArrowLeftIcon />
        </S.Button>
        <S.Button className="right" onClick={() => handleNavigation('next')}>
          <S.ArrowRightIcon />
        </S.Button>
        <Slider ref={slideRef} {...sliderSettings}>
          {data.images.map((image: string) => (
            <img key={image} src={image} alt={data.title} className="gallery" />
          ))}
        </Slider>
      </S.Content>
      <S.Content className="text">
        <S.Wrapper>
          <S.Title>{data.title}</S.Title>
          <S.Author>{data.author}</S.Author>
          <S.Text dangerouslySetInnerHTML={{ __html: data.text }} />
        </S.Wrapper>
      </S.Content>
    </S.Container>
  );
};

export { GalleryLeft };
